import Reveal from 'reveal.js'
import '@/node_modules/reveal.js/dist/reveal.css'
// import '@/node_modules/reveal.js/dist/theme/black.css'

const PresentationElements = document.querySelectorAll('.Presentation')
const PresentationThemeSwitch = document.querySelector(
  '.Presentation-themeSwitch',
)
const PresentationPathElement = document.querySelector('.Presentation-path')
let idleTimeout
const idleTime = 3000

function addPresentationActiveClass(el) {
  el.classList.remove('Presentation--idle')
  clearTimeout(idleTimeout)

  idleTimeout = setTimeout(() => {
    el.classList.add('Presentation--idle')
  }, idleTime)
}

if (PresentationElements.length > 0) {
  const deck = new Reveal({
    // plugins: [Markdown],
    // embedded: true,
  })

  deck.configure({
    keyboard: {
      33: 'prev', // go to the next slide when the ENTER key is pressed
      34: 'next',
    },
  })

  // deck.initialize({ touch: true, width: 1280, height: 720 })
  deck.initialize({
    width: '100%',
    height: '100%',
    margin: 0,
    minScale: 1,
    maxScale: 1,
    transition: 'fade',
  })

  deck.on('ready', (event) => {
    PresentationPathElement.innerHTML =
      event.currentSlide.getAttribute('data-url')
  })

  deck.on('slidechanged', (event) => {
    PresentationPathElement.innerHTML =
      event.currentSlide.getAttribute('data-url')
  })
}

Array.prototype.forEach.call(
  PresentationElements,
  function (presentationElement) {
    presentationElement.addEventListener('mousemove', () => {
      addPresentationActiveClass(presentationElement)
    })

    PresentationThemeSwitch.addEventListener('click', () => {
      if (presentationElement.classList.contains('Presentation--themeDark')) {
        PresentationThemeSwitch.setAttribute('aria-pressed', false)
      } else {
        PresentationThemeSwitch.setAttribute('aria-pressed', true)
      }

      presentationElement.classList.toggle('Presentation--themeDark')
    })
  },
)
